import {
  INNER_GRID_WIDTH,
  INNER_GRID_X_PADDING,
  BP_TABLET_7,
  BP_DESKTOP,
} from './constants'

// Browser not supporting element.closest() also doesnt’ support Promise.
function isElementClosestSupported() {
  return typeof window.Element.prototype.closest === 'function'
}

export function polyfillNeeded() {
  return !isElementClosestSupported()
}

export function isMobile() {
  return window.innerWidth < BP_DESKTOP
}

export function isTablet7() {
  return window.innerWidth >= BP_TABLET_7
}

export function calculateSpaceAroundInnerGrid() {
  const width = window.innerWidth

  return width < INNER_GRID_WIDTH
    ? INNER_GRID_X_PADDING
    : (width - INNER_GRID_WIDTH) / 2
}

export function hasClosest(element, selector) {
  return element.closest(selector) !== null
}

export function hasTwoItemsWithSameHeight(elements) {
  return (
    elements.length === 2 &&
    elements[0].clientHeight === elements[1].clientHeight
  )
}

export function stripInnerHTML(element) {
  element.innerHTML = ''
  return element.outerHTML
}

export function randomFromInterval(min = 0, max = 1) {
  return Math.random() * (max - min) + min
}

function randomIntFromInterval(min = 0, max = 1) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function randomIndex(array, min = 0, max = array.length - 1) {
  return randomIntFromInterval(min, max)
}

export function removePreload({ classList }) {
  classList.remove('still-waiting-for-js', 'preloading', 'transitioning')
}



// WEBPACK FOOTER //
// ./resources/js/app/helpers.js